import { render, staticRenderFns } from "./no-conformidades.vue?vue&type=template&id=3ffe6608&scoped=true"
import script from "./no-conformidades.vue?vue&type=script&lang=js"
export * from "./no-conformidades.vue?vue&type=script&lang=js"
import style0 from "./no-conformidades.vue?vue&type=style&index=0&id=3ffe6608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffe6608",
  null
  
)

export default component.exports